export const isActive = (index, activeEventIndex) => {
    return index === activeEventIndex;
};
export const isCompleted = (index, activeEventIndex) => {
    return index < activeEventIndex;
};
